export const BACKOFFICE_SESSION_TIMEOUT_MS = 2 * 60 * 60 * 1000
export const BACKOFFICE_SESSION_WARNING_MS = 5 * 60 * 1000
export const BACKOFFICE_SESSION_REFRESH_INTERVAL_MS = 10 * 60 * 1000

export const BACKOFFICE_SESSION_TIMEOUT_LABEL_EN = '2 hours'
export const BACKOFFICE_SESSION_TIMEOUT_LABEL_FR = '2 heures'
